import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                VTabs,
                {
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                [_c(VTab, [_vm._v("General")])],
                1
              ),
              _c(
                VTabsItems,
                {
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                [
                  _c(
                    VTabItem,
                    { staticClass: "pt-2" },
                    [
                      _c(
                        "b-container",
                        { attrs: { fluid: "" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { lg: "6" } },
                                [
                                  _c("h6", [_vm._v("Original")]),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "sm",
                                        label: "Organization",
                                        "label-cols": "4",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          size: "sm",
                                          type: "text",
                                          readonly: "",
                                        },
                                        model: {
                                          value: _vm.objOrigin.organization,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.objOrigin,
                                              "organization",
                                              $$v
                                            )
                                          },
                                          expression: "objOrigin.organization",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "sm",
                                        label: "Data Operator",
                                        "label-cols": "4",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          size: "sm",
                                          type: "text",
                                          readonly: "",
                                        },
                                        model: {
                                          value: _vm.objOrigin.data_operator,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.objOrigin,
                                              "data_operator",
                                              $$v
                                            )
                                          },
                                          expression: "objOrigin.data_operator",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "sm",
                                        label: "Domain",
                                        "label-cols": "4",
                                      },
                                    },
                                    [
                                      _c("b-form-select", {
                                        attrs: {
                                          size: "sm",
                                          type: "text",
                                          disabled: "",
                                          options: _vm.selectDomain,
                                        },
                                        model: {
                                          value: _vm.objOrigin.kdomain,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.objOrigin,
                                              "kdomain",
                                              $$v
                                            )
                                          },
                                          expression: "objOrigin.kdomain",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "sm",
                                        label: "Subdomain",
                                        "label-cols": "4",
                                      },
                                    },
                                    [
                                      _c("b-form-select", {
                                        attrs: {
                                          size: "sm",
                                          type: "text",
                                          disabled: "",
                                          options: _vm.selectSubdomain,
                                        },
                                        model: {
                                          value: _vm.objOrigin.ksubdomain,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.objOrigin,
                                              "ksubdomain",
                                              $$v
                                            )
                                          },
                                          expression: "objOrigin.ksubdomain",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "sm",
                                        label: "Sensitive Data",
                                        "label-cols": "4",
                                      },
                                    },
                                    [
                                      _c("b-form-checkbox", {
                                        attrs: { size: "sm", disabled: "" },
                                        model: {
                                          value: _vm.objOrigin.sensitive_data,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.objOrigin,
                                              "sensitive_data",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "objOrigin.sensitive_data",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "sm",
                                        label: "Environment",
                                        "label-cols": "4",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          size: "sm",
                                          type: "text",
                                          readonly: "",
                                        },
                                        model: {
                                          value: _vm.objOrigin.environment,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.objOrigin,
                                              "environment",
                                              $$v
                                            )
                                          },
                                          expression: "objOrigin.environment",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "sm",
                                        label: "Description",
                                      },
                                    },
                                    [
                                      _c("b-form-textarea", {
                                        staticClass: "input-mini",
                                        attrs: {
                                          size: "sm",
                                          rows: "3",
                                          "max-rows": "3",
                                          type: "text",
                                          "no-resize": "",
                                          readonly: "",
                                        },
                                        model: {
                                          value:
                                            _vm.objOrigin.object_description,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.objOrigin,
                                              "object_description",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "objOrigin.object_description",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { lg: "6" } },
                                [
                                  _c("h6", [_vm._v("Request")]),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "sm",
                                        label: "Organization",
                                        "label-cols": "4",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        class: {
                                          resaltador:
                                            _vm.diffRequest.organization,
                                        },
                                        attrs: {
                                          size: "sm",
                                          type: "text",
                                          readonly: "",
                                        },
                                        model: {
                                          value: _vm.objRequest.organization,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.objRequest,
                                              "organization",
                                              $$v
                                            )
                                          },
                                          expression: "objRequest.organization",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "sm",
                                        label: "Data Operator",
                                        "label-cols": "4",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        class: {
                                          resaltador:
                                            _vm.diffRequest.data_operator,
                                        },
                                        attrs: {
                                          size: "sm",
                                          type: "text",
                                          readonly: "",
                                        },
                                        model: {
                                          value: _vm.objRequest.data_operator,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.objRequest,
                                              "data_operator",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "objRequest.data_operator",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "sm",
                                        label: "Domain",
                                        "label-cols": "4",
                                      },
                                    },
                                    [
                                      _c("b-form-select", {
                                        class: {
                                          resaltador: _vm.diffRequest.kdomain,
                                        },
                                        attrs: {
                                          size: "sm",
                                          type: "text",
                                          disabled: "",
                                          options: _vm.selectDomain,
                                        },
                                        model: {
                                          value: _vm.objRequest.kdomain,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.objRequest,
                                              "kdomain",
                                              $$v
                                            )
                                          },
                                          expression: "objRequest.kdomain",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "sm",
                                        label: "Subdomain",
                                        "label-cols": "4",
                                      },
                                    },
                                    [
                                      _c("b-form-select", {
                                        class: {
                                          resaltador:
                                            _vm.diffRequest.ksubdomain,
                                        },
                                        attrs: {
                                          size: "sm",
                                          type: "text",
                                          disabled: "",
                                          options: _vm.selectSubdomain,
                                        },
                                        model: {
                                          value: _vm.objRequest.ksubdomain,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.objRequest,
                                              "ksubdomain",
                                              $$v
                                            )
                                          },
                                          expression: "objRequest.ksubdomain",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "sm",
                                        label: "Sensitive Data",
                                        "label-cols": "4",
                                      },
                                    },
                                    [
                                      _c("b-form-checkbox", {
                                        class: {
                                          resaltador:
                                            _vm.diffRequest.sensitive_data,
                                        },
                                        attrs: { size: "sm", disabled: "" },
                                        model: {
                                          value: _vm.objRequest.sensitive_data,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.objRequest,
                                              "sensitive_data",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "objRequest.sensitive_data",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "sm",
                                        label: "Environment",
                                        "label-cols": "4",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        class: {
                                          resaltador:
                                            _vm.diffRequest.environment,
                                        },
                                        attrs: {
                                          size: "sm",
                                          type: "text",
                                          readonly: "",
                                        },
                                        model: {
                                          value: _vm.objRequest.environment,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.objRequest,
                                              "environment",
                                              $$v
                                            )
                                          },
                                          expression: "objRequest.environment",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "sm",
                                        label: "Description",
                                      },
                                    },
                                    [
                                      _c("b-form-textarea", {
                                        staticClass: "input-mini",
                                        class: {
                                          resaltador:
                                            _vm.diffRequest.object_description,
                                        },
                                        attrs: {
                                          size: "sm",
                                          rows: "3",
                                          "max-rows": "3",
                                          type: "text",
                                          "no-resize": "",
                                          readonly: "",
                                        },
                                        model: {
                                          value:
                                            _vm.objRequest.object_description,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.objRequest,
                                              "object_description",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "objRequest.object_description",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("hr"),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "sm",
                                label: "Request reason",
                              },
                            },
                            [
                              _c(VTextarea, {
                                attrs: {
                                  filled: "",
                                  dense: "",
                                  size: "sm",
                                  rows: "3",
                                  "max-rows": "3",
                                  type: "text",
                                  "no-resize": "",
                                  readonly: "",
                                },
                                model: {
                                  value: _vm.item.commentary,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.item, "commentary", $$v)
                                  },
                                  expression: "item.commentary",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.showFooter
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    "label-size": "sm",
                                    label: "Message to reply",
                                  },
                                },
                                [
                                  _c(VTextarea, {
                                    attrs: {
                                      outlined: "",
                                      dense: "",
                                      size: "sm",
                                      rows: "3",
                                      "max-rows": "3",
                                      type: "text",
                                      "no-resize": "",
                                    },
                                    model: {
                                      value: _vm.response_text2,
                                      callback: function ($$v) {
                                        _vm.response_text2 = $$v
                                      },
                                      expression: "response_text2",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { sm: "12", lg: "12" } },
                        [
                          _c(
                            "b-alert",
                            {
                              attrs: {
                                show: _vm.dismissCountDown,
                                dismissible: "",
                                variant: "danger",
                              },
                              on: {
                                dismissed: function ($event) {
                                  _vm.dismissCountDown = 0
                                },
                                "dismiss-count-down": _vm.countDownChanged,
                              },
                            },
                            [
                              _c("p", [_vm._v(_vm._s(_vm.dangerMessage))]),
                              _c("b-progress", {
                                attrs: {
                                  variant: "danger",
                                  max: _vm.dismissSecs,
                                  value: _vm.dismissCountDown,
                                  height: "4px",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }